import { Scale, Shield, Headphones, FileCheck, CheckCircle2, Award } from 'lucide-react';
import { Button } from './ui/button';
import { motion } from 'framer-motion';
import { Reveal } from './motion/Reveal';
import { StaggerGroup, StaggerItem } from './motion/Stagger';

const MotionButton = motion(Button);

export const Services = () => {
  const services = [
    {
      icon: Scale,
      title: 'Especialistas no seu caso',
      description: 'Nossa equipe é expert em direito do consumidor. Sabemos exatamente o que fazer pra você ganhar.',
      features: ['Análise completa do caso', 'Documentação certinha', 'Representação total'],
    },
    {
      icon: Shield,
      title: 'Zero riscos pra você',
      description: 'Não cobramos nada adiantado. Só ganhamos quando você ganha. Simples assim.',
      features: ['Sem custos iniciais', 'Sem surpresas', 'Pagamento só no sucesso'],
    },
    {
      icon: Headphones,
      title: 'Suporte de verdade',
      description: 'Nada de robôs! Você fala com pessoas reais que entendem sua situação.',
      features: ['Atendimento humanizado', 'Atualizações constantes', 'Sempre disponível'],
    },
    {
      icon: FileCheck,
      title: 'Tudo pelo celular',
      description: 'Resolve tudo sem sair de casa. É 100% digital, rápido e sem papelada.',
      features: ['Cadastro online', 'Envio de documentos fácil', 'Acompanhe pelo app'],
    },
  ];

  const scrollToContact = () => {
    const element = document.querySelector('#contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="servicos"
      data-testid="services-section"
      className="py-20 bg-slate-50"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <Reveal delay={0.1} className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold mb-4">
            <Award className="w-4 h-4" />
            <span>Por que escolher a gente?</span>
          </div>
          <h2
            data-testid="services-title"
            className="text-3xl md:text-4xl font-bold text-slate-900 mb-4"
          >
            A gente faz o trabalho pesado por você
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Enquanto você cuida da sua vida, nossa equipe cuida do seu caso.
            Sem estresse, sem complicação.
          </p>
        </Reveal>

        {/* Services Grid */}
        <StaggerGroup staggerDelay={0.1} startDelay={0.2} className="grid md:grid-cols-2 gap-6 mb-12">
          {services.map((service, index) => (
            <StaggerItem
              key={index}
              data-testid={`service-card-${index}`}
              className="bg-white p-8 rounded-2xl border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_-15px_rgba(37,99,235,0.25)] hover:border-blue-200 transition-all duration-500 ease-[cubic-bezier(0.23,1,0.32,1)] hover:-translate-y-2"
            >
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <service.icon className="w-7 h-7 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-slate-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 mb-4 leading-relaxed">
                    {service.description}
                  </p>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center gap-2 text-sm text-slate-700">
                        <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0" />
                        <span className="font-medium">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>

        {/* CTA */}
        <Reveal delay={0.5} className="text-center">
          <MotionButton
            data-testid="services-cta"
            onClick={scrollToContact}
            size="lg"
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.97 }}
            className="bg-blue-600 hover:bg-blue-700 text-white rounded-full px-10 py-6 text-lg font-bold shadow-[0_8px_30px_rgba(37,99,235,0.3)] hover:shadow-[0_20px_40px_-15px_rgba(37,99,235,0.6)] transition-[background-color,box-shadow] duration-500 ease-[cubic-bezier(0.23,1,0.32,1)]"
          >
            Quero resolver meu problema agora
          </MotionButton>
          <p className="text-slate-500 text-sm mt-4">É grátis e leva menos de 2 minutos</p>
        </Reveal>
      </div>
    </section>
  );
};
